var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRectangleRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 690,
    height: 372,
    viewBox: "0 0 690 372",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20.4243C0 9.37864 8.95431 0.424316 20 0.424316H390C555.685 0.424316 690 134.739 690 300.424V351.963C690 363.008 681.046 371.963 670 371.963H20C8.9543 371.963 0 363.008 0 351.963V20.4243Z",
    fill: "#83E4DA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectangleRounded);
export default __webpack_public_path__ + "static/media/rectangle-rounded.dbdf590420f8bbf85f5163258c7001f8.svg";
export { ForwardRef as ReactComponent };